import { createSelector } from 'reselect';

import { State } from '../rootReducer';
import { CategoryState, ActionTypes } from './types';

export const getCategoryState = (state: State) => state.category;

export const getIsPending = createSelector([getCategoryState], (s: CategoryState) => s.state === ActionTypes.PENDING);
export const getCategory = createSelector([getCategoryState], (s: CategoryState) => s.data);
